import type { ToastProps } from '@iheartjane/reefer';
import { Flex } from '@iheartjane/reefer';
import { useCallback, useEffect, useState } from 'react';

import styles from './Toast.module.css';

export const Toast = ({
  label,
  id,
  onClose,
  time = 3000,
  variant,
}: ToastProps) => {
  const [animateClass, setAnimateClass] = useState(styles['animateIn']);

  const handleClose = useCallback(() => {
    setAnimateClass(styles['animateOut']);
    setTimeout(() => onClose(id), 220);
  }, [id, onClose]);

  useEffect(() => {
    const timeout = setTimeout(() => handleClose(), time);

    return () => {
      clearTimeout(timeout);
    };
  }, [handleClose, time]);

  return (
    <div className={animateClass}>
      <Flex mb={4}>
        <Flex
          className={styles[`container--${variant || 'default'}`]}
          px={32}
          py={24}
          borderRadius="sm"
        >
          {label}
        </Flex>
      </Flex>
    </div>
  );
};
